import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import DELETE_COMMENT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/delete_comment_outline_light_24.svg';

export const config = {
    id: ActionType.DELETE_COMMENT,
    icon: DELETE_COMMENT_ICON,
    content: i18n.t('删除批注'),
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        tooltip: config.content,
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: ActionType.DELETE_COMMENT,
        content: i18n.t<string>('删除批注'),
    },
    {
        name: ActionType.DELETE_COMMENT_GROUP,
        content: i18n.t<string>('删除该组批注'),
    },
    {
        name: ActionType.DELETE_PAGE_COMMENT,
        content: i18n.t<string>('删除当前页面中所有批注标记'),
    },
    {
        name: ActionType.DELETE_ALL_COMMENT,
        content: i18n.t<string>('删除此文档中所有批注标记'),
    },
];
